import { Injectable } from "@angular/core";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import { ActionWithPayload } from "@obg/ngrx-utils";
import { AppError } from "@obg/ngx.core";
import { TelemetryService } from "@obg/ngx.global.evo";
import { GtmEventAction } from "@obg/ngx.gtm/adaptive";
import { map, tap } from "rxjs/operators";

import { ACCOUNT_SETTINGS_ACTION_TYPE } from "../../account-settings/account-settings.action";

@Injectable()
export class AccountSettingsTelemetryEffect {
	passwordChangedSuccess$ = createEffect(
		() =>
			this.actions$.pipe(
				ofType(ACCOUNT_SETTINGS_ACTION_TYPE.changePasswordSuccess),
				tap(() =>
					this.service.track({
						event: GtmEventAction.ChangePasswordSuccess,
					})
				)
			),
		{ dispatch: false }
	);

	passwordChangedFail$ = createEffect(
		() =>
			this.actions$.pipe(
				ofType(ACCOUNT_SETTINGS_ACTION_TYPE.changePasswordFail),
				map((action: ActionWithPayload<AppError>) => action.payload),
				tap((payload: AppError) =>
					this.service.track({
						event: GtmEventAction.ChangePasswordFailed,
						Error: payload.code,
					})
				)
			),
		{ dispatch: false }
	);

	constructor(
		private actions$: Actions,
		private service: TelemetryService
	) {}
}
